export const RecordEnum = {
    RecordInit: 0, // 初始化
    RecordReady: 1, // 准备录制
    Recording: 2, // 正在录制
    RecordEnd: 3 // 录制完成
}
export const RecordStr = {
    [RecordEnum.RecordInit]: '未开始录制',
    [RecordEnum.RecordReady]: '未开始录制',
    [RecordEnum.Recording]: '正在录制中',
    [RecordEnum.RecordEnd]: '录音处理中',
}
export const RecordClassName = {
    [RecordEnum.RecordInit]: 'recordReady',
    [RecordEnum.RecordReady]: 'recordReady',
    [RecordEnum.Recording]: 'recording',
    [RecordEnum.RecordEnd]: 'recordReady',
}